import { List, fromJS } from 'immutable';
import { EDITOR_TYPES, isDimensionReportEditorSchema } from 'reporting-data/tsTypes/editorTypes';
import { BaseDimensionEditor } from './BaseDimensionEditor';
import { BAR, COLUMN, DATA_WELL } from 'reporting-data/constants/chartTypes';
import { AGGREGATION, TIME_SERIES } from 'reporting-data/constants/configTypes';
import { DATE, DATE_TIME } from 'reporting-data/constants/property-types';
import { getConfigType, getDateRangeFilterValue, getDimensions, getReportConfig, getReportProcessors } from 'reporting-data/report/configReportGetters';
import { getCustomWidgetType, getReportChartType } from 'reporting-data/report/reportGetters';
import { isConfigReport, isMultiConfigReport } from 'reporting-data/tsTypes/reportTypes';
//@ts-expect-error Untyped import
import { isMismatchedDimensionDateFilterPropertyTimeSeries } from 'reporting-data/properties/isMismatchedDimensionDateFilterPropertyTimeSeries';
import { setProcessorType } from 'reporting-data/report/configReportSetters';
import { setDimensions, setFilterGroupsByConfigName } from 'reporting-data/report/multiConfigReportSetters';
//@ts-expect-error Untyped import
import Widgets from 'reporting-ui-components/components/customWidgets/constants/widgets';
import * as PROCESSOR_TYPES from 'reporting-data/constants/processorTypes';
import { logError } from 'reporting-data/monitoring/logger';
import { getFilterGroupsByConfigName } from 'reporting-data/report/multiConfigReportGetters';
//@ts-expect-error Untyped import
import getDefaultFrequency from 'reporting-ui-components/lib/getDefaultFrequency';
import { canBeComparisonConfig } from '../../reportEditors/common/comparisonHelpers';
import { ReportOptionsCategories } from '../../singleReportViewer/fullPage/sidebar/categorized/ReportOptionCategory';
import { getReportWithValidRangeAndFrequency } from '../common/dateRangeHelpers';
import getConfigDataType from '../common/getConfigDataType';
import { getGoalReportConfigName, updateGoalFilterGroupsForDimension, getReportIsSubAppWithGoals } from './subAppDimensionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const isCompareValid = report => canBeComparisonConfig(report) && !isMismatchedDimensionDateFilterPropertyTimeSeries(report);
export const strategy = {
  isSupportedForReport: report => {
    return isConfigReport(report) && [AGGREGATION, TIME_SERIES].includes(getConfigType(report));
  },
  updateReport: (report, dimensionProperties) => {
    const isTimeSeries = dimensionProperties.length > 0 && [DATE, DATE_TIME].includes(dimensionProperties[0].type);
    const dimensionNames = dimensionProperties.map(property => property.name);
    const dateRange = getDateRangeFilterValue(getReportConfig(report));
    let defaultFrequency;
    try {
      defaultFrequency = getDefaultFrequency(dateRange.toJS());
    } catch (ex) {
      logError({
        error: new Error('Error getting default frequency', {
          cause: ex
        }),
        extra: {
          report
        }
      });
    }
    let updatedReport = report.setIn(['config', 'dimensions'], fromJS(dimensionNames)).setIn(['config', 'configType'], isTimeSeries ? TIME_SERIES : AGGREGATION).updateIn(['config', 'frequency'], currentFrequency => {
      if (isTimeSeries) {
        return currentFrequency || defaultFrequency;
      }
      return null;
    }).update('chartType', chartType => getCustomWidgetType(report) === Widgets.SALES_QUOTA ? isTimeSeries ? COLUMN : BAR : chartType);
    if (isMultiConfigReport(report)) {
      updatedReport = setDimensions(updatedReport, getDimensions(report), List(dimensionNames));
    }
    const goalReportConfigName = getGoalReportConfigName(updatedReport);
    if (getReportIsSubAppWithGoals(report) && goalReportConfigName) {
      const reportAsMultiConfigReport = updatedReport;
      const currentGoalFilterGroups = getFilterGroupsByConfigName(reportAsMultiConfigReport, goalReportConfigName);
      const updatedGoalFilterGroups = updateGoalFilterGroupsForDimension(currentGoalFilterGroups, dimensionNames[0]);
      updatedReport = setFilterGroupsByConfigName(reportAsMultiConfigReport, goalReportConfigName, updatedGoalFilterGroups);
    }
    if (!isTimeSeries) {
      if (getReportProcessors(report).contains(PROCESSOR_TYPES.ACCUMULATE)) {
        // Toggle Cumulative OFF for aggregation reports
        updatedReport = setProcessorType(updatedReport, PROCESSOR_TYPES.ACCUMULATE);
      }
    }
    const withCorrectedDateFields = getReportWithValidRangeAndFrequency(updatedReport);
    return withCorrectedDateFields.updateIn(['config', 'compare'], currentCompare => isCompareValid(withCorrectedDateFields) ? currentCompare : null);
  },
  getDataType: getConfigDataType,
  getCurrentValue: report => getDimensions(report).toJS(),
  isClearable: (editorType, report) => editorType === EDITOR_TYPES.BREAKDOWN && getCustomWidgetType(report) !== Widgets.PIPELINE_SNAPSHOTS || getReportChartType(report) === DATA_WELL
};
const SingleObjectDimensionEditorComponent = props => {
  return /*#__PURE__*/_jsx(BaseDimensionEditor, Object.assign({}, props, {
    strategy: strategy,
    schema: props.schema
  }));
};
export const SingleObjectDimensionEditor = {
  matchesEditorType: (report, schema) => {
    if (!isDimensionReportEditorSchema(schema)) {
      return false;
    }
    return strategy.isSupportedForReport(report);
  },
  EditorComponent: SingleObjectDimensionEditorComponent,
  category: ReportOptionsCategories.Group
};